import { WriteHook, useMutationManager } from 'state-manager'

import { deleteDocumentIsolated as deleteDocumentService } from '../service'

export const useDeleteDocumentIsolated: WriteHook<number, void> = (opts) =>
  useMutationManager<number, void>(deleteDocumentService, opts)
